import { Select, InputText } from '@ui/src';
import { ExpandableRowContentTypes } from './types';

import cn from './aml.module.css';

const ExpandableRowContent = ({
  title,
  list,
  value,
  risk,
  name,
  isEditable,
  withoutOpacity,
  officialRiskItems,
}: ExpandableRowContentTypes): React.JSX.Element => {
  let valueContent;

  if (list) {
    valueContent = (
      <Select
        list={list}
        placeholder="Value is empty"
        name={`select-value-${name}`}
        value={value}
        selectWrapperClassName={`${cn.expandableRowContentSelect} ${
          cn.disabledSelect
        } ${withoutOpacity ? cn.withoutOpacity : ''}`}
        disabled
        borderless
      />
    );
  } else {
    valueContent = value;
  }

  return (
    <div
      className={`${cn.expandableRowContent} ${
        officialRiskItems ? cn.withFlexWrap : ''
      }`}
    >
      <div className={cn.expandableRowContentLeft}>
        {title && <div className={cn.expandableRowContentTitle}>{title}</div>}
        <div className={cn.expandableRowContentValue}>{valueContent}</div>
      </div>
      <div className={cn.expandableRowContentRight}>
        <InputText
          name={`risk-input-${name}`}
          value={risk}
          placeholder=""
          labelClassName={`${cn.expandableRowContentInputLabel} ${cn.noHover}`}
          className={`borderless ${cn.expandableRowContentInput} ${
            isEditable ? cn.whiteBackground : ''
          }`}
          disabled
        />
      </div>
      {officialRiskItems && officialRiskItems?.length > 0 && (
        <div className={cn.officialRiskItems}>
          {officialRiskItems?.map((item) => (
            <div className={cn.officialRiskItem} key={item.id}>
              <div className={cn.officialRiskItemTitle}>{item.name}</div>
              <div className={cn.officialRiskItemValue}>
                <InputText
                  name={`official-input-${item.id}`}
                  value={item.value?.toString()}
                  placeholder=""
                  labelClassName={`${cn.expandableRowContentInputLabel} ${cn.noHover}`}
                  className={`borderless ${cn.expandableRowContentInput} ${
                    isEditable ? cn.whiteBackground : ''
                  }`}
                  disabled
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExpandableRowContent;
